export default "__VITE_ASSET__7vZJWO0m__"